import { render, staticRenderFns } from "./FreightBillPoint.vue?vue&type=template&id=ef094aac"
import script from "./FreightBillPoint.vue?vue&type=script&lang=js"
export * from "./FreightBillPoint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ef094aac')) {
      api.createRecord('ef094aac', component.options)
    } else {
      api.reload('ef094aac', component.options)
    }
    module.hot.accept("./FreightBillPoint.vue?vue&type=template&id=ef094aac", function () {
      api.rerender('ef094aac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/FreightBillPoint.vue"
export default component.exports